export default "__VITE_ASSET__ecc28444__"